module.exports = __webpack_public_path__ + "static/media/xigua.13121f8b.png";